import type { QueryClient } from '@tanstack/react-query'
import { api } from '~/lib/tuyau'
import { TOKEN_STORAGE_KEY } from '~/utils/api'
import { isMfaEnrollmentRefusal } from './account-security'

/** Un jeton du BO est posé : sans lui, l'état ne se lit pas. */
export const hasAdminSession = () => Boolean(window.localStorage.getItem(TOKEN_STORAGE_KEY))

/**
 * État du double facteur de l'admin connecté (`GET /auth/mfa-admin`), partagé par le socle
 * (enrôlement obligatoire), le bandeau d'avertissement et l'écran « Sécurité du compte ». Sans
 * jeton (page de connexion), aucune requête. Une minute de fraîcheur : le bandeau monte juste après
 * le socle, qui vient de la charger ; connexion, déconnexion et activation rechargent la page.
 */
export const adminMfaStatusQueryOptions = () => ({
  ...api.auth.adminMfaStatus.queryOptions({}, { staleTime: 60_000 }),
  enabled: hasAdminSession(),
})

/**
 * Requête refusée parce que l'obligation vise désormais le compte (date passée onglet ouvert, droit
 * sensible ajouté, double facteur réinitialisé) : l'état est relu, et le socle passe à
 * l'enrôlement sans attendre un rechargement.
 */
export const refreshMfaStatusOnRefusal = (queryClient: QueryClient, error: unknown) => {
  if (!isMfaEnrollmentRefusal(error)) return
  void queryClient.invalidateQueries({ queryKey: adminMfaStatusQueryOptions().queryKey })
}
